import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpfeatures1putPutFeaturesAppFeatureKeyResponseSchema = jsonObject
export type tcpfeatures1putPutFeaturesAppFeatureKeyResponse = z.infer<typeof tcpfeatures1putPutFeaturesAppFeatureKeyResponseSchema>
